@if (strategy) {
  <div class="filter">
    <h3>Filter-strategy</h3>
    <div class="body">
      <mat-form-field>
        <mat-label>Enter the strategy title</mat-label>
        <input matInput type="text" placeholder="" [(ngModel)]="strategy.title" autocomplete="off">
      </mat-form-field>
      <app-filters-edit #filtersEdit [filters]="strategy.consumptionFilters"></app-filters-edit>
    </div>
  </div>
}

